import React from "react";

import styles from "../../../../styles/integrations.module.scss";

import { EnvironmentStorage } from "@tools/EnvironmentStorage";
import { Context } from "pages/Integrations";
import { Label, Button, Drawer, Loading, Input } from "@components";
import { FileReaderInput } from "shared/components/FileReaderInput";
import { IntegrationsAPI } from "providers/IntegrationsAPI";

export default class ApplePayAddCertificateDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: false,
      loading: false,
      file: null,
    };
  }

  componentDidMount() {}

  async onSave() {
    try {
      const { onSave } = this.props;
      const { file } = this.state;

      this.setState({ loading: true });

      const environmentId = EnvironmentStorage.getEnvironment().id;

      const certificateResponse =
        await IntegrationsAPI.upsertApplePayCertificate(environmentId, {
          file: {
            name: file.name,
            data: file.content,
          },
        });

      this.setState({ loading: false });

      if (certificateResponse.getErrors([]).length === 0) {
        onSave && onSave();
      } else {
        alert({
          text: `Não foi possível registrar o certificado - ${
            certificateResponse.getErrors()[0]
          }`,
        });
      }
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  setFile(file) {
    this.setState({
      file: file,
    });
  }

  render() {
    const { loading, loadingPage, file } = this.state;
    const { onClose } = this.props;

    const isValid = !!file?.content;

    return (
      <Drawer
        visible
        onClose={onClose}
        closeInFade
        title={"Apple Pay - Certificado"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={() => this.onSave()}
            loading={loading}
            disabled={loading || !isValid}
          >
            Salvar
          </Button>
        }
      >
        <Context />

        {loadingPage ? (
          <div className="d-flex justify-center align-center h-100">
            <Loading fullScreen />
          </div>
        ) : (
          <div className={styles.scrollContainer}>
            <Label>Selecione o arquivo</Label>
            <FileReaderInput
              file={file}
              acceptedTypes={[".cer"]}
              onFileLoaded={(file) => {
                console.log(file);
                this.setFile(file);
              }}
            />
          </div>
        )}
      </Drawer>
    );
  }
}
